export class VentaReguladores {
    _id_venta_reguladores: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    tipo_regulador: String;
    cantidad_reguladores: Number;
    precio: Number;
    archivo_cedula_identidad: String;
    archivo_cedula_identidad_reverso: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }